export const AnnouncementEndpoints = {
  list: '/announcement/list',
  details: (id: string) => `/announcement/${id}`,
  receipts: (id: string) => `/announcement/list/receipts/${id}`,
  create: '/announcement/create',
  uploadMedia: '/announcement/upload/file',
  edit: (id: string) => `/announcement/edit/${id}`,
  delete: (id: string) => `/announcement/del/${id}`,
  publish: (id: string) => `/announcement/publish/${id}`,
  validity: (id: string) => `/announcement/validity/${id}`,
  close: (id: string) => `/announcement/close/${id}`,
  myPending: '/announcement/list/pending',
  myList: '/announcement/list/received',
  seen: (id: string) => `/announcement/seen/${id}`,
  acknowledge: (id: string) => `/announcement/acknowledge/${id}`,
  dismiss: (id: string) => `/announcement/dismiss/${id}`,
};
